export interface ShiftListItem {
  id: number;
  title: string;
  code?: string;
  startTime: string;
  endTime: string;
  color: string;
  assignedTeams: number;
  assignedUsers: number;
  status?: string;
}

export interface ShiftDetail {
  id: number;
  title: string;
  code?: string;
  startTime: string;
  endTime: string;
  color: string;
  assignedTeams: number;
  assignedUsers: number;
  status?: string;
  assignments: ShiftAssignment[];
}

export const ShiftAssignmentKind = { TEAM: 'team', USER: 'user' } as const;
export type ShiftAssignmentKind = (typeof ShiftAssignmentKind)[keyof typeof ShiftAssignmentKind];

/** A shift-detail assignment for a team, grouped across its members. */
export interface TeamShiftAssignmentItem {
  kind: typeof ShiftAssignmentKind.TEAM;
  teamId: number;
  teamName: string;
  startDate: string;
  endDate: string;
  memberCount: number;
}

/** A shift-detail assignment for a single, directly-assigned user. */
export interface UserShiftAssignmentItem {
  kind: typeof ShiftAssignmentKind.USER;
  id: number; // shift_assign row id (for delete-by-id)
  userId: number;
  userName: string;
  startDate: string;
  endDate: string;
}

export type ShiftAssignment = TeamShiftAssignmentItem | UserShiftAssignmentItem;

export interface CreateShiftInput {
  title: string;
  code?: string;
  startTime: string;
  endTime: string;
  color?: string;
}

export interface UpdateShiftInput {
  title?: string;
  code?: string;
  startTime?: string;
  endTime?: string;
  color?: string;
}

export interface AssignShiftInput {
  shiftId: number;
  userId: number; // Required to match backend
  startDate: string;
  endDate: string;
}

export interface AssignShiftToTeamInput {
  shiftId: number;
  teamId: number;
  startDate: string;
  endDate: string;
}

/** A shift assigned to a team, grouped across its members. */
export interface TeamShiftAssignment {
  shiftId: number;
  title: string;
  code?: string;
  color: string;
  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
  memberCount: number;
}

export interface RemoveTeamShiftInput {
  teamId: number;
  shiftId: number;
  startDate: string;
  endDate: string;
}

export interface TeamAssignmentResult {
  message: string;
  status: boolean;
  summary: {
    total: number;
    successful: number;
    conflicts: number;
    failed: number;
  };
  successful: Array<{
    userId: number;
    userName: string;
    assignmentId: number;
  }>;
  conflicts: Array<{
    userId: number;
    userName: string;
    existingAssignment: {
      startDate: string;
      endDate: string;
    };
  }>;
  failed: Array<{
    userId: number;
    userName: string;
    reason: string;
  }>;
}
